
export default {
  className: 'walletrecord',
  title: '充值记录',
  render: (record) => {
    let stringFields = ['transactionId']
    return stringFields.map(f => record[f]).join('-')
  },
  fields: [
    {
      name: 'user',
      searchKey: ['nickName', 'phone'],
      render: (record) => {
        return (record && record.user && record.user.nickName) || ''
      },
      listWhere: (where) => {
        where.isAdmin = {
          $ne: true
        }
      }
    },
    { name: 'money' }
  ],
  search: [
    'user'
  ],
  action: {
    delete: false,
    edit: false,
    create: false
  },
  hooks: {
    beforeFetch ({ where }) {
      where.type = 'recharge'
    }
  }
}
